export default "__VITE_ASSET__999708ad__"